var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInactiveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#697D99"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66732 11.1668C8.20708 11.1668 7.83398 11.5399 7.83398 12.0002C7.83398 12.4604 8.20708 12.8335 8.66732 12.8335H15.334C15.7942 12.8335 16.1673 12.4604 16.1673 12.0002C16.1673 11.5399 15.7942 11.1668 15.334 11.1668H8.66732Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1673 12.0002C21.1673 17.0628 17.0633 21.1668 12.0007 21.1668C6.93804 21.1668 2.83398 17.0628 2.83398 12.0002C2.83398 6.93755 6.93804 2.8335 12.0007 2.8335C17.0633 2.8335 21.1673 6.93755 21.1673 12.0002ZM19.5006 12.0002C19.5006 16.1423 16.1428 19.5002 12.0007 19.5002C7.85851 19.5002 4.50065 16.1423 4.50065 12.0002C4.50065 7.85803 7.85851 4.50016 12.0007 4.50016C16.1428 4.50016 19.5006 7.85803 19.5006 12.0002Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveIcon);
export default __webpack_public_path__ + "static/media/inactiveIcon.66b65a76bb19a806d24d26a0a841dddd.svg";
export { ForwardRef as ReactComponent };